<template>
  <div class="coming-container">
    <a-result title="Coming June 2022!" class="coming-message">
      <template #extra>
        <a-button type="primary" @click="goHome" class="tf-primary tf-btn-primary">
          Go Dashboard
        </a-button>
      </template>
    </a-result>
  </div>
</template>
<script>
export default {
  methods: {
    goHome() {
      this.$router.push({
        name: 'dashboard',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.coming-container {
  background-image: url('https://truelifeorg.s3.amazonaws.com/assets/truelife-MAINTENANCE.jpg');
  width: 100%;
  height: 100%;
  position: absolute;
  background-size: cover;
}
.coming-message {
  top: 45%;
  position: absolute;
  transform: translateY(-45%);
  text-align: center;
  width: 100%;
}
</style>
<style lang="scss">
.coming-message {
  .ant-result-title {
    color: #fff !important;
    font-size: 36px !important;
  }

  .ant-result-icon {
    display: none !important;
  }
}
</style>
